/**
 * Radix 浮层（弹出层、菜单与子菜单、右键菜单、下拉选择）统一的出现与消失：淡入淡出并从 95% 缩放，
 * 出现时朝弹出方向带 4px 位移，150ms 强 ease-out。各浮层另加自己的
 * `origin-[var(--radix-<name>-content-transform-origin)]`，缩放才会从触发器而不是浮层中心开始。
 */
export const SURFACE_MOTION_CLASS =
  'data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 ' +
  'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 ' +
  'data-[side=top]:slide-in-from-bottom-1 data-[side=bottom]:slide-in-from-top-1 ' +
  'data-[side=left]:slide-in-from-right-1 data-[side=right]:slide-in-from-left-1 ' +
  'duration-150 ease-[cubic-bezier(0.16,1,0.3,1)]'

/** Tooltip 的打开状态叫 delayed-open / instant-open，其余与 {@link SURFACE_MOTION_CLASS} 相同。 */
export const TOOLTIP_MOTION_CLASS =
  'data-[state=delayed-open]:animate-in data-[state=delayed-open]:fade-in-0 data-[state=delayed-open]:zoom-in-95 ' +
  'data-[state=instant-open]:animate-in data-[state=instant-open]:fade-in-0 data-[state=instant-open]:zoom-in-95 ' +
  'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 ' +
  'data-[side=top]:slide-in-from-bottom-1 data-[side=bottom]:slide-in-from-top-1 ' +
  'data-[side=left]:slide-in-from-right-1 data-[side=right]:slide-in-from-left-1 ' +
  'duration-150 ease-[cubic-bezier(0.16,1,0.3,1)]'
